export default "__VITE_ASSET__Carc76rA__"